import axios from "axios";

export default axios.create({
  baseURL: import.meta.env.VITE_APP_SERVER_ROUTE,
  timeout: 25000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  }
})